import React, { useEffect } from 'react';
import Icon, { COLORS, ICONS } from '../icon';
import GRInput from './gr-input';
import { getNumberedFieldName, getUserFriendlyPictureName } from './gr-picture-input';
import { FieldOption, FieldValue } from '../../types/stylepacks';

interface DraggingGrPictureProps {
	fieldName: string;
	options: FieldOption[] | null;
	variables?: any[];
	values?: Record<string, FieldValue>;
	defaultValues?: Record<string, string | object> | undefined;
	count?: number;
}

export default function DraggingGrPicture(props: DraggingGrPictureProps) {
	const {
		fieldName,
		options,
		variables,
		values,
		defaultValues,
		count = 1,
	} = props;

	const [pictureName, setPictureName] = React.useState('preview.png');
	const isUploadedPicture = pictureName !== 'preview.png';

	useEffect(() => {
		const value = values?.[getNumberedFieldName(fieldName, count)];
		if (typeof value === 'string') {
			setPictureName(getUserFriendlyPictureName(value));
		}
	}, [values]);

	return (
		<div
			className="gr-input-picture dragging"
			key={`picture-${count}`}
			id={`picture-${count}`}
		>
			{!!defaultValues?.oneToManyLabel && (
				<div className="gr-input-picture-label dragging">
					<div className="gr-input-picture-drag">
						<div className="gr-input-picture-label-drag">
							<Icon name={ICONS.DRAG} size={12} color={COLORS.TEXT_GRAY_500}/>
						</div>
						{typeof defaultValues?.oneToManyLabel === "string" ? defaultValues.oneToManyLabel : 'Picture'}&nbsp;{count}
					</div>
				</div>
			)}
			<div className="gr-input-picture-fields dragging">
				{(variables?.length ?? 0) > 0 && variables?.map((variable: any) => {
					const numberedFieldName = getNumberedFieldName(variable.userData, count);
					const backUpFieldName = getNumberedFieldName(variable.userData, 2);

					let value = values?.[numberedFieldName] ?? '';
					if (!value && count >= 2 && typeof defaultValues?.[backUpFieldName] === 'string') {
						value = defaultValues?.[backUpFieldName] as string;
					}

					return (
						<GRInput
							key={variable.name}
							fieldName={getNumberedFieldName(variable.userData, count)}
							friendlyName={variable.name}
							fieldType={variable.type}
							onChange={() => {}}
							options={options}
							value={value}
						/>
					);
				})}
			</div>
			<div className="gr-input-picture-row">
				<div
					className="gr-input-picture-thumbnail"
					style={{
						backgroundImage: `url(${
							values?.[getNumberedFieldName(fieldName, count)]
								?? defaultValues?.[getNumberedFieldName(fieldName, 2)]
								?? ''
						})`,
					}}
				>
					&nbsp;
				</div>
				<div className="gr-input-picture-name">
					{pictureName}
				</div>
				<div
					className="gr-input-picture-button"
				>
					{isUploadedPicture ? 'Replace' : 'Add Image'}
					<Icon
						name={ICONS.CARROT_DOWN}
						size={12}
						color={COLORS.TEXT_GRAY_200}
					/>
				</div>
			</div>
		</div>
	);
}
